import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const Archive2Icon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 2H10L8.586 0.586C8.211 0.211 7.702 0 7.172 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

Archive2Icon.propTypes = {
  sx: PropTypes.object,
};

export default Archive2Icon;
